import { Link } from "react-router-dom";

const guides = [
  {
    title: "Robot software architecture",
    description: "Understand how ROS 2, SLAM, perception, planning, simulation, safety layers and fleet dashboards fit together in a working robot stack.",
    to: "/robotics-software"
  },
  {
    title: "Robot components and hardware",
    description: "Compare actuators, reducers, encoders, batteries, controllers, sensors and end effectors through the lens of real deployment limits.",
    to: "/robot-components"
  },
  {
    title: "Robotics companies by category",
    description: "Separate humanoid builders, AMR vendors, industrial arm makers, drone teams, medical robotics firms, software platforms and component suppliers.",
    to: "/robotics-companies"
  },
  {
    title: "Robotics data collection",
    description: "Learn what a useful robot dataset records cameras, actions, force, failures, operator interventions, task context and environment changes.",
    to: "/robotics-data-collection"
  }
];

export default function SEOResearchBlock({ compact = false }) {
  const visibleGuides = compact ? guides.slice(0, 3) : guides;

  return (
    <section className="site-shell py-12 sm:py-16">
      <div className="glass-panel rounded-[2rem] p-6 sm:p-8">
        <p className="eyebrow-chip">Robotics editorial guides</p>
        <h2 className="mt-4 max-w-4xl text-3xl font-black tracking-tight text-neutral-950 sm:text-4xl">Start with the robot system, then choose the article</h2>
        <p className="mt-5 max-w-4xl text-base leading-8 text-neutral-600">
          TechniaHQRobot groups robotics coverage around working systems the robot body, the sensor stack, the software layer, the deployment environment and the evidence that a machine can repeat a task outside a polished demo.
        </p>
      </div>

      <div className="mt-6 grid gap-5 lg:grid-cols-2">
        {visibleGuides.map((guide) => (
          <article key={guide.to} className="soft-card p-5 sm:p-6">
            <h3 className="text-xl font-black tracking-tight text-neutral-950">{guide.title}</h3>
            <p className="mt-3 text-sm leading-7 text-neutral-600">{guide.description}</p>
            <Link to={guide.to} className="mt-5 inline-flex rounded-full bg-neutral-950 px-4 py-2 text-sm font-black text-white transition hover:bg-blue-700">
              Open guide
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}
